let pending;
export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve();
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    const timeout = setTimeout(() => finish(Error("Checkout took too long to load. Please try again.")), 15000);
    const finish = error => {
      clearTimeout(timeout);
      if (error) { script.remove(); pending = null; reject(error); } else resolve();
    };
    script.onload = () => finish(window.Razorpay ? null : Error("Could not load checkout"));
    script.onerror = () => finish(Error("Could not load checkout. Check your connection."));
    document.body.appendChild(script);
  });
  return pending;
}
